function PlainOrPrinted({ data, state, dispatch, setTab }) {
    const type = state.plain_or_printed.type;
    const typeData = data.plain_or_printed[type];

    const handleChangeType = (value) => {
        dispatch({ type: 'plain_or_printed.type', value: value });
    }

    return (
        <div className="tab">
            <div className="cols">
                <div>
                    <img src={typeData.image} />
                </div>
                <div>
                    <h1 className="title">{data.product.post_title}</h1>
                    <div dangerouslySetInnerHTML={{ __html: data.plain_or_printed.main_description }}></div>
                    <div className="switch">
                        <button className={`switch__left ${type === 'plain' ? 'is-active' : ''}`} onClick={() => handleChangeType('plain')}>Plain</button>
                        <button className={`switch__right ${type === 'printed' ? 'is-active' : ''}`} onClick={() => handleChangeType('printed')}>Printed</button>
                    </div>
                    <div className="margin-top-2" dangerouslySetInnerHTML={{ __html: typeData.description }}></div>
                </div>
            </div>
            <div className='tab__actions'>
                <span></span>
                <button className='btn' onClick={() => setTab('size_and_quantity')}>Next</button>
            </div>
        </div>
    );
}

export default PlainOrPrinted
